<template>
  <dialog-add
    icon="business_center"
    :title="title"
    is-fullscreen
    :is-on="true"
    :on-close="onCancel"
  >
    <template v-slot:content>
      <forms-creator-program-business class="elevation-1" @saved="$emit('saved')" />
    </template>
  </dialog-add>
</template>

<script>
export default {
  emits: ['saved'],
  methods: {
    onCancel() {
      this.$router.push({ name: 'creator-program-businesses', query: this.$route.query });
    },
  },
  computed: {
    title() {
      if (this.$route.name === 'creator-program-businesses-new') {
        return this.$t('create_business');
      } else {
        return this.$t('change_business');
      }
    },
  },
};
</script>
